import { combine, createEffect, createEvent, createStore } from 'effector';
import { ApiUtils } from '@shared/utils';
import { MiscApi, RequestStrategyEnum, type GetCorporateTravelContactsResponse, type WithSignal } from '@shared/api';

const getCorporateTravelContactsEffect = createEffect(({ signal }: WithSignal = {}) => MiscApi.getCorporateTravelContacts(signal));
const clearEvent = createEvent();

const $dataStore = createStore<GetCorporateTravelContactsResponse | null>(null)
  .on(getCorporateTravelContactsEffect.done, (_, data) => data.result.data ?? null)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(true)
  .on(getCorporateTravelContactsEffect.pending, (_, data) => data)
  .on(getCorporateTravelContactsEffect.fail, () => false)
  .on(getCorporateTravelContactsEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getCorporateTravelContactsEffect, () => null)
  .on(getCorporateTravelContactsEffect.fail, () => 'Something went wrong while fetching Corporate Travel Contacts. Please try again.')
  .on(getCorporateTravelContactsEffect.done, () => null)
  .reset(clearEvent);

export const $corporateTravelContactsStore = {
  events: {
    getCorporateTravelContacts: ApiUtils.wrapperApi(getCorporateTravelContactsEffect, RequestStrategyEnum.Once, { $data: $dataStore }).trigger,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
